import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import IconButton from './IconButton';
import FacebookIcon from '../Icons/Facebook';

const FacebookButton = ({ intl: { formatMessage }, onClick }) => (
  <IconButton
    icon={<FacebookIcon fontSize="large" />}
    label={formatMessage({ id: 'sso.facebook' })}
    onClick={onClick}
    size="large"
  />
);

FacebookButton.propTypes = {
  intl: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default injectIntl(FacebookButton);
